// extracted by mini-css-extract-plugin
export default {"gridButton":"Property_gridButton__y+bK5","tabButton":"Property_tabButton__mDgvC","deleteButton":"Property_deleteButton__zOiWs","card":"Property_card__pXNnH"};